import { useEffect, useState } from 'react';
import ArrowDown from "../../../../Assets/ArrowDown.svg";
import ArrowRight from "../../../../Assets/ArrawRight.svg";
import TickMark from '../../../../Assets/Modals/TickMark.svg';
import { useDispatch, useSelector } from 'react-redux';
import { updateSelectedCategories, updateSelectedCollections, updateSelectedTags } from '../../../../Features/inventoryManagementSlice';
import { showToast } from '../../../../Components/Toaster/Toaster';

function areArraysEqual(arr1, arr2) {
    if (arr1.length !== arr2.length) return false;
    if (arr1.length === 0 && arr2.length === 0) return true;

    const sortedArr1 = arr1.map(obj => JSON.stringify(obj)).sort();
    const sortedArr2 = arr2.map(obj => JSON.stringify(obj)).sort();

    return sortedArr1.every((str, index) => str === sortedArr2[index]);
}

function FilterKebab({ categories, collections, tags, kebabOpen, boxRef }) {
    const dispatch = useDispatch();

    const [selectedList, setSelectedList] = useState('');

    const [buttonAvailable, setButtonAvailable] = useState(false);
    const [kebabVisible, setKebabVisible] = useState(false);

    const filters = useSelector((state) => state.inventoryManagement.filters);

    const [localCategories, setLocalCategories] = useState([]);
    const [localCollections, setLocalCollections] = useState([]);
    const [localTags, setLocalTags] = useState([]);

    const handleListSelect = (listId) => {
        if(selectedList === listId) {
            setSelectedList('');
        }
        else {
            setSelectedList(listId);
        }
    }

    const handleCategoryClick = (e, category) => {
        e.stopPropagation();

        let isSelected = localCategories.some(selected => selected.id === category.id);

        if(isSelected) {
            let filteredList = localCategories.filter(item => item.id !== category.id);
            setLocalCategories(filteredList);
        }
        else {
            setLocalCategories([ ...localCategories, category]);
        }
    }

    const handleCollectionClick = (e, collection) => {
        e.stopPropagation();

        let isSelected = localCollections.some(selected => selected.id === collection.id);

        if(isSelected) {
            let filteredList = localCollections.filter(item => item.id !== collection.id);
            setLocalCollections(filteredList);
        }
        else {
            setLocalCollections([ ...localCollections, collection]);
        }
    }

    const handleTagClick = (e, tag) => {
        e.stopPropagation();

        let isSelected = localTags.some(selected => selected === tag);

        if(isSelected) {
            let filteredList = localTags.filter(item => item !== tag);
            setLocalTags(filteredList);
        }
        else {
            setLocalTags([ ...localTags, tag]);
        }
    }

    useEffect(() => {
        if(!areArraysEqual(localCategories, filters.selectedCategories) || !areArraysEqual(localCollections, filters.selectedCollections) || !areArraysEqual(localTags, filters.selectedTags)) {
            setButtonAvailable(true);
        }
        else {
            setButtonAvailable(false);
        }
    }, [localCategories, localCollections, localTags, filters]);

    const handleApplyClick = () => {
        if(buttonAvailable) {
            dispatch(updateSelectedCategories(localCategories));
            dispatch(updateSelectedCollections(localCollections));
            dispatch(updateSelectedTags(localTags));
        }
        else {
            showToast('Add filters.', 'warning');
        }
    }

    useEffect(() => {
        if(kebabOpen) {
            setKebabVisible(true);
        } else {
            setKebabVisible(false);
        }
    }, [kebabOpen]);

    useEffect(() => {
        if(filters.selectedCategories.length > 0) {
            setLocalCategories(filters.selectedCategories);
        }
        if(filters.selectedCollections.length > 0) {
            setLocalCollections(filters.selectedCollections);
        }
        if(filters.selectedTags.length > 0) {
            setLocalTags(filters.selectedTags);
        }
    }, [filters]);

    const handleClearFilters = () => {
        dispatch(updateSelectedCategories([]));
        setLocalCategories([]);
        dispatch(updateSelectedCollections([]));
        setLocalCollections([]);
        dispatch(updateSelectedTags([]));
        setLocalTags([]);
    }

    return (
        <div ref={boxRef} onClick={(e) => {e.stopPropagation()}} className={`${kebabVisible ? 'opacity-100 visible' : 'opacity-0 invisible'} transition-all duration-150 ease-in-out absolute right-0 top-9 z-10 w-60 pb-3 rounded-lg overflow-hidden bg-[#FFFFFF] shadow-[0px_0px_12px_0px_#0000003D]`}>
            <div className="bg-[#F5F5F5] p-[7px_12px_8px_12px] flex items-center justify-between">
                <h1 className='font-semibold text-[14px] leading-[22px] text-left text-[#121212]'>Filter by</h1>

                <button onClick={handleClearFilters} className='outline-none text-[#4F46E5] font-semibold text-[12px] leading-5'>Clear filters</button>
            </div>

            <div className="w-full flex flex-col gap-2 my-2">
                <div className="w-full flex flex-col">
                    <button onClick={() => handleListSelect('category')} className='w-full flex items-center justify-between px-3 py-1'>
                        Category

                        <div className="flex items-center gap-[10px]">
                            {
                                localCategories?.length > 0 &&
                                <div className="size-4 flex items-center justify-center bg-primaryColor text-[12px] leading-3 font-semibold text-[#FFFFFF] rounded-full">
                                    {localCategories.length}
                                </div>
                            }

                            <div className="size-6 flex items-center justify-center">
                                <div className="size-4 flex items-center justify-center">
                                    <img src={selectedList === 'category' ? ArrowDown : ArrowRight} alt="" />
                                </div>
                            </div>
                        </div>
                    </button>

                    <div className="flex flex-col max-h-48 overflow-y-scroll">
                        {
                            selectedList === 'category' && 
                            (categories?.map(category => {
                                let isSelected = localCategories.some(selected => selected.id === category.id);

                                return (
                                    <div key={category.id} onClick={(e) => handleCategoryClick(e, category)} className="px-3 py-2 border-t border-[#EAEAEA] w-full flex items-center gap-[10px]">
                                        <div className={`size-6 flex items-center justify-center rounded-md ${isSelected ? 'border-none bg-primaryAccent' : 'border border-[#D1D5DB]'} `} >
                                            <img className='select-none' src={isSelected ? TickMark : undefined} alt="" />
                                        </div>

                                        <p className='line-clamp-2 w-[calc(100%-24px)] overflow-hidden text-ellipsis break-words'>{category.categoryName}</p>
                                    </div>
                                )
                            }))
                        }
                    </div>
                </div>

                <div className="flex flex-col">
                    <button onClick={() => handleListSelect('collections')} className='w-full flex items-center justify-between px-3 py-1'>
                        Collections

                        <div className="flex items-center gap-[10px]">
                            {
                                localCollections?.length > 0 &&
                                <div className="size-4 flex items-center justify-center bg-primaryColor text-[12px] leading-3 font-semibold text-[#FFFFFF] rounded-full">
                                    {localCollections.length}
                                </div>
                            }

                            <div className="size-6 flex items-center justify-center">
                                <div className="size-4 flex items-center justify-center">
                                    <img src={selectedList === 'collections' ? ArrowDown : ArrowRight} alt="" />
                                </div>
                            </div>
                        </div>
                    </button>

                    <div className="flex flex-col max-h-48 overflow-y-scroll">
                        {
                            selectedList === 'collections' && 
                            (collections?.map(collection => {
                                let isSelected = localCollections.some(selected => selected.id === collection.id);

                                return (
                                    <div key={collection.id} onClick={(e) => handleCollectionClick(e, collection)} className="px-3 py-2 border-t border-[#EAEAEA] w-full flex items-center gap-[10px]">
                                        <div className={`size-6 flex items-center justify-center rounded-md ${isSelected ? 'border-none bg-primaryAccent' : 'border border-[#D1D5DB]'} `} >
                                            <img className='select-none' src={isSelected ? TickMark : undefined} alt="" />
                                        </div>

                                        <p className='line-clamp-2 w-[calc(100%-24px)] overflow-hidden text-ellipsis break-words'>{collection.CollectionName}</p>
                                    </div>
                                )
                            }))
                        }
                    </div>
                </div>

                <div className="flex flex-col">
                    <button onClick={() => handleListSelect('tags')} className='w-full flex items-center justify-between px-3 py-1'>
                        Tags

                        <div className="flex items-center gap-[10px]">
                            {
                                localTags?.length > 0 &&
                                <div className="size-4 flex items-center justify-center bg-primaryColor text-[12px] leading-3 font-semibold text-[#FFFFFF] rounded-full">
                                    {localTags.length}
                                </div>
                            }

                            <div className="size-6 flex items-center justify-center">
                                <div className="size-4 flex items-center justify-center">
                                    <img src={selectedList === 'tags' ? ArrowDown : ArrowRight} alt="" />
                                </div>
                            </div>
                        </div>
                    </button>

                    <div className="flex flex-col max-h-48 overflow-y-scroll">
                        {
                            selectedList === 'tags' && 
                            (tags?.map(tag => {
                                let isSelected = localTags.some(selected => selected === tag);

                                return (
                                    <div key={tag} onClick={(e) => handleTagClick(e, tag)} className="px-3 py-2 border-t border-[#EAEAEA] w-full flex items-center gap-[10px]">
                                        <div className={`size-6 flex items-center justify-center rounded-md transition ${isSelected ? 'border-none bg-primaryAccent' : 'border border-[#D1D5DB]'} `} >
                                            <img className='select-none' src={isSelected ? TickMark : undefined} alt="" />
                                        </div>

                                        <p className='line-clamp-2 w-[calc(100%-24px)] overflow-hidden text-ellipsis break-words'>{tag}</p>
                                    </div>
                                )
                            }))
                        }
                    </div>
                </div>
            </div>

            <div className="px-3">
                <button onClick={handleApplyClick} className={`${buttonAvailable ? 'bg-primaryColor hover:bg-primaryAccent' : 'bg-buttonDisabledBg cursor-not-allowed'} text-buttonText w-full px-4 py-2 rounded font-semibold text-[12px] leading-5`}>Apply Filters</button>
            </div>
        </div>
    );
}

export default FilterKebab;
